var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mesomerie"},[_c('p',[_vm._v("\n        Moleküle mit Grenzstrukturformeln."),_c('br'),_vm._v("\n        z.B. Benzol\n    ")])])}]

export { render, staticRenderFns }